import FacilityAiAssignmentsContent from '@UI/Pages/AiAssignments/FacilityAiAssignments/FacilityAiAssignmentsContent';
import AiAssignmentsNotifications from '@UI/Pages/AiAssignments/Shared/AiAssignmentsNotifications';
import LevelSwitch from '@Guidelines/Component/LevelSwitch';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import useAccessibleNavigationLevels from '@UI/Hooks/useAccessibleNavigationLevels';
import type * as React from 'react';

/**
 * Assembles the screen: header, the data-owning `FacilityAiAssignmentsContent`, and the notifications
 * shared by the three affectation screens. The eyebrow is the
 * section label followed by the current organization's name once resolved.
 */
const FacilityAiAssignmentsPage: React.FC = () => {
	const { currentOrganization } = useCurrentOrganization();
	const levels = useAccessibleNavigationLevels('ai-models');

	const eyebrow =
		currentOrganization !== null ? `CONFIGURATION · ${currentOrganization.name}` : 'CONFIGURATION';

	return (
		<PageContainer>
			<PageHeader
				eyebrow={eyebrow}
				title="Modèles de l’agence"
				description="Affectez un modèle à chaque usage pour l’agence courante : hérité de la structure puis du compte tant qu’aucun n’est défini ici."
				actions={<LevelSwitch ariaLabel="Niveau des modèles d'IA" levels={levels} />}
			/>
			<FacilityAiAssignmentsContent />
			<AiAssignmentsNotifications />
		</PageContainer>
	);
};

export default FacilityAiAssignmentsPage;
